/**
 * @generated SignedSource<<3e427cca7579ff7916644ec39454934d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifiedAuthenticationModalHeaderQuery$variables = {
  clubSlug: string;
};
export type VerifiedAuthenticationModalHeaderQuery$data = {
  readonly unauthenticatedClub: {
    readonly " $fragmentSpreads": FragmentRefs<"ClubLogoFragment_UnauthenticatedClub">;
  } | null | undefined;
};
export type VerifiedAuthenticationModalHeaderQuery = {
  response: VerifiedAuthenticationModalHeaderQuery$data;
  variables: VerifiedAuthenticationModalHeaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clubSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "clubSlug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifiedAuthenticationModalHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnauthenticatedClub",
        "kind": "LinkedField",
        "name": "unauthenticatedClub",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ClubLogoFragment_UnauthenticatedClub"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifiedAuthenticationModalHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnauthenticatedClub",
        "kind": "LinkedField",
        "name": "unauthenticatedClub",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnauthenticatedImage",
            "kind": "LinkedField",
            "name": "logoImage",
            "plural": false,
            "selections": [
              {
                "alias": "publicId",
                "args": null,
                "kind": "ScalarField",
                "name": "renderingKey",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b52576bfc235858286beacc1457606e",
    "id": null,
    "metadata": {},
    "name": "VerifiedAuthenticationModalHeaderQuery",
    "operationKind": "query",
    "text": "query VerifiedAuthenticationModalHeaderQuery(\n  $clubSlug: String!\n) {\n  unauthenticatedClub(slug: $clubSlug) {\n    ...ClubLogoFragment_UnauthenticatedClub\n  }\n}\n\nfragment ClubLogoFragment_UnauthenticatedClub on UnauthenticatedClub {\n  slug\n  logoImage {\n    publicId: renderingKey\n  }\n}\n"
  }
};
})();

(node as any).hash = "f683a76db7216df0e6e8cd0cee78a6ce";

export default node;
